import React from 'react';

type ItemType = {
	key: string;
	label: string;
	value: string;
};

interface ExecutionSummaryCardProps {
	title: string;
	items: ItemType[];
}

const ExecutionSummaryCard: React.FC<ExecutionSummaryCardProps> = ({ title, items }) => {
	return (
		<div
			style={{
				backgroundColor: '#EDF0F7',
				padding: '1.5rem',
				borderRadius: '8px',
				height: '100%',
			}}
		>
			<h3
				style={{
					fontSize: '24px',
					fontWeight: 700,
				}}
			>
				{title}
			</h3>
			<div
				style={{
					// backgroundColor: '#2A3A64',
					backgroundColor: 'var(--np-primary-color)',
					height: '1px',
					marginTop: '0.5rem',
					marginBottom: '1rem',
				}}
			/>

			{items.map((item) => (
				<div
					key={item.key}
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						fontWeight: 700,
					}}
				>
					<p>{item.label}</p>
					<p>{item.value}</p>
				</div>
			))}
		</div>
	);
};

export default ExecutionSummaryCard;
